import ContainerDetail from '../organisms/ContainerDetail';
import CircularProgress from '@mui/material/CircularProgress';
import { withStyles } from 'tss-react/mui';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import queryString from 'query-string';
import { loadContainer, loadEventHistory } from '../../store/actions/containerActions';
import { errorMessage, successMessage } from '../../store/actions/messageActions';
import { getSelectedContainer } from '../../store/selectors/selectors';
import LoaderTimeout from '../organisms/LoaderTimeout';
import { useLocation, useNavigate } from 'react-router-dom';

const styles = (theme) => ({
  circularProgress: {
    marginLeft: '50%',
    marginTop: '5%',
  },
  breadBar: {
    marginBottom: theme.spacing(2),
  },
});

function ReleaseDetail(props) {
  const { classes, container, loadContainer, loadEventHistory, selectedUserType } = props;
  const [containerLoaded, setContainerLoaded] = useState(false);
  const [queryParams, setQueryParams] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (containerLoaded === false) {
      if (location.search === '') {
        return navigate('/');
      }
      const query = queryString.parse(location.search);
      loadContainer(query);
      setQueryParams(query);
    }
    setContainerLoaded(true);
  }, []);

  const loadEventsAction = () => {
    if (queryParams !== null) {
      loadEventHistory(queryParams);
    }
  };

  return (
    <>
      {container.loading && <CircularProgress className={classes.circularProgress} />}
      {!container.loading && containerLoaded && (
        <ContainerDetail
          container={container}
          selectedUserType={selectedUserType}
          loadEventsAction={loadEventsAction}
        />
      )}
      <LoaderTimeout loading={container.loading} />
    </>
  );
}

function mapStateToProps(state) {
  return {
    container: getSelectedContainer(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      loadContainer,
      loadEventHistory,
      errorMessage,
      successMessage,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(ReleaseDetail, styles));
